import React, { useState, useEffect } from 'react';
import { Alert, Button } from "react-bootstrap";
import Select from 'react-select';
import PropTypes from "prop-types";
import { getFromApi } from '../utilities/NetUtilities';
import { buildUrl } from '../helper/handler';
import moment from "moment";


Nota.propTypes = {
    nota: PropTypes.object,
    close: PropTypes.func,
    action: PropTypes.func,
    lavoratoriMap: PropTypes.object,
    sediMap: PropTypes.object
}

function Nota({ nota, close, action, lavoratoriMap, sediMap, setMessageEsterno }) {

    const [message, setMessage] = useState([]);
    const [lavoratori, setLavoratori] = useState([])
    const [tipi, setTipi] = useState([])
    const [sedi, setSedi] = useState([])
    const [sediScelte, setSediScelte] = useState([])
    const [lavoratore, setLavoratore] = useState("")
    const [tipo, setTipo] = useState({ value: "varie", label: "varie" });
    const [inizio, setInizio] = useState("");
    const [fine, setFine] = useState("");
    const [descrizione, setDescrizione] = useState("");

    useEffect(() => {
        setMessageEsterno([]);
    }, [setMessageEsterno]);

    useEffect(() => {
        const setMessageFromApi = (data) => {
            setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }]);
        };

        function getLavoratori() {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
            if (organizzazioneMap) {
                const setLavoratoriFromApi = (data) => {
                    setLavoratori(data.lavoratori.map(lavoratore => ({ "value": lavoratore.id, "label": lavoratore.nomeCognome })));
                };
                const urlLavoratori = buildUrl('lavoratori', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo });
                getFromApi(urlLavoratori, setLavoratoriFromApi, setMessageFromApi);
            }
        }

        function getSedi() {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
            if (organizzazioneMap) {
                const setSediFromApi = (data) => {
                    const options = data.sedi.map(sede => ({ "value": sede.id, "label": sede.descrizione }));
                    setSedi([{ value: 'TUTTE', label: 'Tutte le sedi' }, ...options]);
                }
                const url = buildUrl('sedi', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo });
                getFromApi(url, setSediFromApi, setMessageFromApi);
            }
        }

        function getTipiNota() {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
            if (organizzazioneMap) {
                const setTipiFromApi = (data) => {
                    setTipi(data.tipi.map(tipo => ({ "value": tipo, "label": tipo })));
                };
                const urlTipiNota = buildUrl('tipinota', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo });
                getFromApi(urlTipiNota, setTipiFromApi, setMessageFromApi);
            }
        }
        getLavoratori();
        getTipiNota();
        getSedi();
        if (nota) {
            setInizio(moment(nota.inizio).format("YYYY-MM-DD"))
            setFine(moment(nota.fine).format("YYYY-MM-DD"))
            setLavoratore({ "value": nota.lavoratoreId, "label": lavoratoriMap[nota.lavoratoreId] })
            setSediScelte(nota.sedi.map(sede => ({ "value": sede, "label": sediMap[sede] })))
            setDescrizione(nota.descrizione);
            setTipo({ "value": nota.tipo, "label": nota.tipo });
        }
    }, [nota, lavoratoriMap, sediMap])


    const salva = () => {
        setMessage([])
        if (!inizio || !fine || !descrizione) {
            alert("Attenzione: alcuni campi obbligatori non sono compilati")
        } else if (fine < inizio) {
            alert("Attenzione: la data di fine è antecedente a quella di inizio")
        } else if (!lavoratore && sediScelte.length === 0) {
            alert("Attenzione: o lavoratore o sedi devono essere compilati")
        } else {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
            if (!nota) { nota = {} }
            nota.id = nota ? nota.id : ""
            nota.inizio = inizio
            nota.fine = fine
            nota.lavoratore = lavoratore.value
            nota.tipoNota = tipo === "" ? "varie" : tipo.value
            nota.sedi = sediScelte.map(sede => sede.value);
            nota.descrizione = descrizione
            nota.organizzazione = organizzazioneMap.nome
            nota.tipoOrganizzazione = organizzazioneMap.tipo
            action(nota, close)
        }
    }

    const handleSediChange = (selectedOptions) => {
        if (selectedOptions && selectedOptions.some(option => option.value === 'TUTTE')) {
            const allSediOptions = sedi.filter(option => option.value !== 'TUTTE');
            setSediScelte(allSediOptions);
        } else {
            setSediScelte(selectedOptions);
        }
    };

    const handleSelectWrapperMouseDown = (e) => {
        e.stopPropagation();
    };

    const printNota = () => {
        return (
            <div className="padding-box">
                <div className="date-container">
                    <div className="date-field">
                        <label htmlFor="inizio" className="inEvidenza">* inizio</label>
                        <input
                            className='form-control'
                            id="inizio"
                            type="date"
                            value={inizio}
                            onChange={(event) => {
                                setInizio(event.target.value);
                            }}
                        />
                    </div>
                    <div className="date-field">
                        <label htmlFor="fine" className="inEvidenza">* fine</label>
                        <input
                            className='form-control'
                            id="fine"
                            type="date"
                            value={fine}
                            onChange={(event) => {
                                setFine(event.target.value);
                            }}
                        />
                    </div>
                </div>
                <div className="date-container">
                    <div className="date-field">
                        <label htmlFor="lavoratore" className="inEvidenza">lavoratore</label>
                        <Select
                            name="lavoratore"
                            instanceId="lavoratore"
                            options={lavoratori}
                            onChange={setLavoratore}
                            placeholder="Seleziona..."
                            value={lavoratore}
                        />
                    </div>
                    <div className="date-field">
                        <label htmlFor="tipo" className="inEvidenza">tipo</label>
                        <Select
                            name="tipo"
                            instanceId="tipo"
                            options={tipi}
                            onChange={setTipo}
                            placeholder="Seleziona..."
                            value={tipo}
                        />
                    </div>
                    <div className="date-field">
                        <label htmlFor="sedi" className="inEvidenza">sedi</label>
                        <div onMouseDown={handleSelectWrapperMouseDown}>
                            <Select
                                name="sedi"
                                instanceId="sedi"
                                id="sedi"
                                options={sedi}
                                onChange={handleSediChange}
                                placeholder="Seleziona..."
                                value={sediScelte}
                                isMulti
                            />
                        </div>
                    </div>
                </div>
                <div className="date-container">
                    <div className="date-field">
                        <label htmlFor="nota" className="inEvidenza">* nota</label>
                        <textarea
                            name="nota"
                            id="contenuto-nota"
                            className='form-control'
                            onChange={(event) => {
                                setDescrizione(event.target.value);
                            }}
                            value={descrizione}
                        />
                    </div>
                </div>
            </div>)
    }

    return (
        <div className="formGroup" id="nota">
            {message &&
                message.map((data, key) => (
                    <Alert variant={data.tipo} id="message" key={key}>
                        {data.descrizione}
                    </Alert>))}
            {printNota()}
            <div className="buttonPopup">
                <Button className="btnGenerale" variant="flat" size="sm" id="salvanota"
                    onClick={salva}>Salva</Button>
                <Button className="btnGenerale" variant="flat" size="sm" id="annulla"
                    onClick={close}>Annulla</Button>
            </div>
        </div>)
}

export default Nota;